// The cube renders live on the landing-page CDN rather than in the bundle —
// they are large transparent PNGs exported from Figma (11894:10107).
const CUBE_IMG = "https://images.nowpurchase.com/landing/";
const cubeA = `${CUBE_IMG}20260929095726_cube-a.png`;
const cubeC = `${CUBE_IMG}20260929095726_cube-c.png`;
const cubeE = `${CUBE_IMG}20260929095727_cube-e.png`;
const cubeI = `${CUBE_IMG}20260929095728_cube-i.png`;
const cubeT = `${CUBE_IMG}20260929095729_cube-t.png`;

// Design size of the tower group (Figma 11894:10107). The cubes overlap each
// other by design, so every block is placed absolutely against this box and
// the whole thing is scaled with an aspect-ratio wrapper.
export const ACE_IT_TOWER = { width: 281, height: 1067 };

// One entry per value — Figma component set 11903:8142 has a variant per cube
// showing the copy that pops out when that cube is picked.
// `rect` is left/top/width/height inside ACE_IT_TOWER.
export const aceItValues = [
  {
    key: "accountability",
    letter: "A",
    img: cubeA,
    title: "Accountability",
    body: "Own the outcome - even when it isn't yours.",
    rect: { left: 16, top: 0, width: 260, height: 245 },
  },
  {
    key: "collaboration",
    letter: "C",
    img: cubeC,
    title: "Collaboration",
    body: "Win people, not arguments. Influence without authority.",
    rect: { left: 0, top: 214, width: 281, height: 218 },
  },
  {
    key: "empathy",
    letter: "E",
    img: cubeE,
    title: "Empathy",
    body: "Lead with curiosity and integrity. Lift the people around you.",
    rect: { left: 16, top: 430, width: 239, height: 213 },
  },
  {
    key: "innovation",
    letter: "I",
    img: cubeI,
    title: "Innovation",
    body: "Challenge norms, experiment boldly, and turn ideas into impact.",
    rect: { left: 26, top: 616, width: 240, height: 238 },
  },
  {
    key: "teamwork",
    letter: "T",
    img: cubeT,
    title: "Teamwork",
    body: "We win together. No silos, no passengers - just builders.",
    rect: { left: 3, top: 798, width: 277, height: 269 },
  },
];

const pct = (part, whole) => `${(part / whole) * 100}%`;

// Turn a design rect into the percentage box the CSS uses.
export const toStyle = ({ left, top, width, height }) => ({
  left: pct(left, ACE_IT_TOWER.width),
  top: pct(top, ACE_IT_TOWER.height),
  width: pct(width, ACE_IT_TOWER.width),
  height: pct(height, ACE_IT_TOWER.height),
});

// Where the tooltip's connector meets the cube: the middle of its front face,
// which sits a little below the block's own centre because of the 3D top face.
export const anchorTop = ({ top, height }) =>
  pct(top + height * 0.52, ACE_IT_TOWER.height);
